// Indexes/Order of DateFormats should be same as below MomentDateFormats
import { DatePlaceholders } from '../enums/DatePlaceholders';
import { DateFormat } from '../enums/DateFormat';

const dateFormats = [
  'dd.MM.yyyy',
  'dd.MM.yyyy HH:mm:ss',
  'MM/dd/yyyy',
  'MM/dd/yyyy HH:mm:ss',
  'yyyy/MM/dd',
  'yyyy/MM/dd HH:mm:ss',
];

// Indexes/Order of MomentDateFormat should be same as above DataFormats
// Moment data format is different from the one we are showing in UI as decribed here https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
const momentDateFormats = [
  'DD.MM.YYYY',
  'DD.MM.YYYY HH:mm:ss',
  'MM/DD/YYYY',
  'MM/DD/YYYY HH:mm:ss',
  'YYYY/MM/DD',
  'YYYY/MM/DD HH:mm:ss',
];

// Should keep the indexes/Order of MomentDateFormat and DateFormats constants same
// Returns the moment date format by mapping UI date format
export function getMomentDateFormat(dateFormat: string) {
  const index = dateFormats.indexOf(dateFormat);
  return index >= 0 ? momentDateFormats[index] : momentDateFormats[0];
}

export function dateFallsInRange(
  date: Date,
  start?: Date | string,
  end?: Date | string
) {
  return (!start || date >= new Date(start)) && (!end || date <= new Date(end));
}

// Return UI date formats
export function getDateFormats() {
  return [...dateFormats];
}

export function getLocaleDateString(
  date?: string | Date,
  formatDatePlaceholder?: DatePlaceholders
) {
  const options = () => {
    if (formatDatePlaceholder === DatePlaceholders.withTime) {
      return {
        year: DateFormat.numeric,
        month: DateFormat.numeric,
        day: DateFormat.numeric,
        hour: DateFormat.numeric,
        minute: DateFormat.numeric,
      };
    } else {
      return {
        year: DateFormat.numeric,
        month: DateFormat.numeric,
        day: DateFormat.numeric,
      };
    }
  };

  // Ignore time before converting the date string if formatDatePlaceholder !== 'withTime'
  const dateString =
    date &&
    `${new Date(date).toLocaleDateString(
      undefined,
      options() as Intl.DateTimeFormatOptions
    )}`;

  switch (formatDatePlaceholder) {
    case DatePlaceholders.withTime: {
      return dateString;
    }
    case DatePlaceholders.open: {
      return date ? dateString : DatePlaceholders.open;
    }
    case DatePlaceholders.na: {
      return date ? dateString : DatePlaceholders.na;
    }
    default: {
      return '';
    }
  }
}
